import { render, staticRenderFns } from "./CategoryDetails.vue?vue&type=template&id=431cfec6&scoped=true&lang=html"
import script from "./CategoryDetails.vue?vue&type=script&lang=js"
export * from "./CategoryDetails.vue?vue&type=script&lang=js"
import style0 from "./CategoryDetails.vue?vue&type=style&index=0&id=431cfec6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431cfec6",
  null
  
)

export default component.exports